import { shallowEqual } from "react-redux";
import { useCarConfigSelector } from "../redux/store";
import { extrasSelector, getExtraCategoriesSelector, packsSelector } from "../utils/selectorUtils";
import useCarConfigServices from "./useCarConfigServices";
import { useAphPacks } from "./useAphPacks";
import { CarConfigConfigureSection } from "../utils/types/SectionTypes";

export const useServicesSectionVisibility = (): boolean => {
    const services = useCarConfigServices();
    // we can add more check here, if more tabs become active

    return !!services?.length;
};

/**
 * Determines the visibility of the footer in the "Packs and Extras" section.
 */
export const usePacksAndExtrasFooterVisibility = (): boolean => {
    const section = useCarConfigSelector(
        (state) => state.carConfigNavigation.activeSection as CarConfigConfigureSection,
    );
    const enabledCategoryFilters = useCarConfigSelector((state) => state.extraFilter.appliedCategoryFilters);
    const packs = useAphPacks(useCarConfigSelector(packsSelector, shallowEqual), enabledCategoryFilters).valid;
    const extras = useCarConfigSelector(extrasSelector, shallowEqual);
    const extraCategories = useCarConfigSelector(getExtraCategoriesSelector, shallowEqual);

    if (section !== CarConfigConfigureSection.Packs) return false;

    const hasPacks = packs.length !== 0;
    const hasExtras = extras.length !== 0;

    return (hasPacks && hasExtras) || extraCategories.length > 0;
};
